import React, { Component } from "react";
import { CSVLink } from "react-csv";
import Header from "./Layout/Header";
import SnagTable from "./TicktingCommon/SnagTable";
import { connect } from "react-redux";
import { TickList, CheckLoader } from "../Redux/action/tickList";
import { dataUser, dataLocation } from "./Helpers/util";
import TicketFilter from "./TicktingCommon/TicketFilter";
import { Navigate } from "react-router-dom";
import MarketingPanel from "../Component/MarketingPanel";
import { getServiceAccess } from "../Redux/action/userActions";
import axios from "axios";
import moment from "moment";
import mixpanel from "mixpanel-browser";
import axiosInstance from "../utils/axiosInstance";
import Select from "react-select";
import RaiseTicket from "./CommonComponent/RaiseTicket";
import SnagFilterExport from "./CommonComponent/SnagFilterExport";
import RaiseSnag from "./CommonComponent/RaiseSnag";
import Sidebar from "../Component/Layout/Sidebar";
import CustomHeader from "../Component/Layout/Header";
import { Layout } from "antd";
import SwSelect from "./Common/SwReactSelect/SwReactSelect";
import SwButton from "./Common/SwButtons/SwButtons";
import AntDDatePicker from "./Common/AntDDateTimePicker/AntDDatePicker";
import dayjs from 'dayjs'
import AntDDropdown from "./Common/AntDDropdown/AntDDropdown";
import SwIconButton from "./Common/SwIconButton/SwIconButton";
import SwLoader from "./Common/SwLoader/SwLoader";
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation()
var LocationObj = JSON.parse(userDataLocal1);
var exportData = [];

class SnagManagement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      TicktingAllListRows: "",
      // raisedBySelect: false,
      locationFilter: 0,
      locations: [],
      locationIds: [],
      ticketType:'',
      projects: [],
      selectedProject: null, // To hold the selected project
      locationError: '', // To handle any error related to location
      status: "All" ,
      status1: 'spoc',
      startDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      company_id: UserObj ? UserObj.company_id : null,
      location: null,
      location1: null,
      locationSpoc: [],
      ticketStatus: [],
      ticketRaisedBy: [],
      collapsed: true,
      pgno: 1,
      row: 25,
      dropdown: false,
      sort: "",
      FilterData: [],
      isSearchVisible: false,
      searchText: "",
      accessServiceLists: [],
      loaderServiceAccess: true,
      userRole: [], 
      loadingExport: (
        <li style={{ color: "#666666d4", cursor: "default" }}>
          <img src="img/submen3.svg" /> Loading Export Ticket Booking
        </li>
      ),
    };



    this.forwordPage = this.forwordPage.bind(this);
    this.pageBackword = this.pageBackword.bind(this);
    this.handelDropdown = this.handelDropdown.bind(this);
  }

  foterSet = (langValue) => {

    this.setState({
      FilterData: langValue,
    });
  };



  toggleCollapsed = () => {
    this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
  };
  // Fetch projects when locationIds or UserObj changes
 

  // Fetch projects based on locationIds
  fetchProjects = async () => {
  
    const { locationIds } = this.state;
    const getCompanyId = UserObj ? UserObj.company_id : null;
  
    try {
      // Use async/await to fetch data
      const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/getProjects/${getCompanyId}`, 
    
        {
          locationIds: locationIds // Pass the array of location IDs
        },
       
      );
  
      // Check the response and update state if successful
      if (response.status === 200 && response.data.statusText === 'SUCCESS') {
        this.setState({ projects: response.data.data });
      }
    } catch (error) {
      // Handle any errors during the API call
      console.error('Error fetching projects:', error);
    }
  };

  handleLocation = (loca) => {
    this.setState({
      FilterData: loca,
    });
  };

  handelDropdown() {
    this.setState({
      dropdown: !this.state.dropdown,
    });
  }

  toggleSearchHandler = () => {
    const isVisible = this.state.isSearchVisible;
    this.setState({
      isSearchVisible: !isVisible,
    });
  };

  StatusMethod = (selectedOption) => {

    this.setState({ status: selectedOption.value });
  };

  StatusMethod1 = (selectedOption) => {
  

    this.setState({ status1: selectedOption.value });
  };
  setSelectsort = (e) => {
    this.setState({
      sort: e.target.value,
    });
    let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let params = {
      pgno: this.state.pgno + 1,
      company_id: newCompanyId?.organizationId,
      row: this.state.row,
      sort: e.target.value,
        ticketType: 'snag'
    };
    if (this.state.selectedProject && this.state.selectedProject !== '') {
      params.projectId = this.state.selectedProject; // Include projectId only if not "All"
    }
    this.props.CheckLoader();
    this.props.TickList(params);
  };

  selectRows = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    let location = (this.state.location1 === 'all')
    ? this.state.locationSpoc?.map((items) => items.centercode) // Send all locations if 'all' is selected
    : this.state.location1 !== null 
      ? this.state.location1 // Send specific location if selected
      : this.state.locationSpoc?.map((items) => items.centercode); 
    let raisedByValue1 = this.state.status === 'All' ? '':this.state.status
    let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let param = {
      pgno: this.state.pgno + 1,
      status: raisedByValue1,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      location: location,
      company_id: newCompanyId?.organizationId,
      row: e.target.value,
      ticketType: 'snag'
      // location:
      //   this.state.FilterData.locationFilter == [""]
      //     ? LocationObj
      //     : this.state.FilterData.locationFilter,
    };
    if (this.state.selectedProject && this.state.selectedProject !== '') {
      param.projectId = this.state.selectedProject; // Include projectId only if not "All"
    }
    
    this.props.TickList(param);
    this.props.CheckLoader();
  };

  setPage = (e) => {
    this.setState({
      pgno: 1,
    });
  };

  handelChangeValLang = (e) => {
   
    // if (e.target.value === 'GGN6') {
    //   this.setState({ raisedBySelect: true })
    // }
    this.setState({
      location1: e.target.value
    });

  };
  handleProjectChange = (event) => {
    const selectedValue = event.target.value; // Get the selected projectId from the event

    // Find the project that matches the selected projectId
    const project = this.state.projects.find(item => item.projectId === selectedValue);


        // Update both selectedProject and ticketType in the state
        this.setState({
            ticketType: project.ticketType,
            selectedProject: selectedValue
        });
   
};

  forwordPage(e) {
    this.setState({
      pgno: this.state.pgno + 1,
    });

    let location = (this.state.location1 === 'all')
    ? this.state.locationSpoc?.map((items) => items.centercode) // Send all locations if 'all' is selected
    : this.state.location1 !== null 
      ? this.state.location1 // Send specific location if selected
      : this.state.locationSpoc?.map((items) => items.centercode); 
    let raisedByValue1 = this.state.status === 'All' ? '':this.state.status
    let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let param = {
      pgno: this.state.pgno + 1,
      company_id: newCompanyId?.organizationId,
      row: this.state.row,
      status: raisedByValue1,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      location: location,

      search: this.state.searchText,
      ticketType: 'snag'
    };
    if (this.state.selectedProject && this.state.selectedProject !== '') {
      param.projectId = this.state.selectedProject; // Include projectId only if not "All"
    }
    this.props.TickList(param);
    this.props.CheckLoader();
  }

  pageBackword(e) {
    this.setState({
      pgno: this.state.pgno - 1,
    });

    let location = (this.state.location1 === 'all')
      ? this.state.locationSpoc?.map((items) => items.centercode) // Send all locations if 'all' is selected
      : this.state.location1 !== null 
        ? this.state.location1 // Send specific location if selected
        : this.state.locationSpoc?.map((items) => items.centercode); 
    let raisedByValue1 = this.state.status === 'All' ? '':this.state.status
    let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let param = {
      status: raisedByValue1,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      location: location,
      // location:["PUN10", "GGN6", "NOI3"],
      pgno: this.state.pgno - 1,
      company_id: newCompanyId?.organizationId,
      row: this.state.row,
      // sort: this.state.sort,
      search: this.state.searchText,
      ticketType: 'snag'
    };
    if (this.state.selectedProject && this.state.selectedProject !== '') {
      param.projectId = this.state.selectedProject; // Include projectId only if not "All"
    }
    this.props.TickList(param);
    this.props.CheckLoader();
  }

  changeFilterData = (event) => {
    let location = (this.state.location1 === 'all')
    ? this.state.locationSpoc?.map((items) => items.centercode) // Send all locations if 'all' is selected
    : this.state.location1 !== null 
      ? this.state.location1 // Send specific location if selected
      : this.state.locationSpoc?.map((items) => items.centercode); 
    const searchText = event.target.value; 
    let newCompanyId = JSON.parse(localStorage.getItem('headData'));// Extract the value from the event
    this.setState({ searchText }, () => {
      let params = {
        company_id: newCompanyId?.organizationId,
        pgno: this.state.pgno,
        row: this.state.row,
        search: this.state.searchText, // Use the extracted searchText
        startDate: this.state.startDate,
        location: location,
        // location:["PUN10", "GGN6", "NOI3"],
        endDate: this.state.endDate,
          ticketType: 'snag'
      };
      if (this.state.selectedProject && this.state.selectedProject !== '') {
        params.projectId = this.state.selectedProject; // Include projectId only if not "All"
      }
      this.props.TickList(params);
    });
  };

  clearSearchBox = () => {
    this.setState({ searchText: "" });
  };




  submitFilter = (e) => {
    e.preventDefault();
  
    // Determine the location
    let location = (this.state.location1 === 'all')
    ? this.state.locationSpoc?.map((items) => items.centercode) // Send all locations if 'all' is selected
    : this.state.location1 !== null 
      ? this.state.location1 // Send specific location if selected
      : this.state.locationSpoc?.map((items) => items.centercode); 
  
    // Determine raisedByValue based on state
    let raisedByValue = this.state.status1; // Adjust as needed
    let raisedByValue1 = this.state.status === 'All' ? '' : this.state.status;
    let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    // Create the parameters object
    let parm = {
      company_id: newCompanyId?.organizationId,
      status: raisedByValue1,
      pgno: this.state.pgno,
      row: this.state.row,
      location: location,
      // location:["PUN10", "GGN6", "NOI3"],
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      raisedBy: raisedByValue,
      ticketType:'snag', 
    };
  
    // Check if "All" is selected in the project dropdown
    if (this.state.selectedProject && this.state.selectedProject !== '') {
      parm.projectId = this.state.selectedProject; // Include projectId only if not "All"
    }
  
    // If status1 is 'me', include userId in parameters
    // if (this.state.status1 === 'me') parm.userId = String(UserObj.rec_id);
     if (this.state.status1 === 'me') parm.userId = String(56793);
  
    // Trigger loading indicator and API call
    this.props.CheckLoader();
    this.props.TickList(parm);
  };

  setuserlist = () => {
    let raisedByValue1 = this.state.status === 'All' ? '':this.state.status
    let raisedByValue = this.state.status1 
    let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let params = {
      company_id: newCompanyId?.organizationId,
      pgno: this.state.pgno,
      row: this.state.row,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      location: this.state.locationSpoc.map((items) => items.centercode),
      // location:["PUN10", "GGN6", "NOI3"],

      status:raisedByValue1,
      // raisedBy:raisedByValue,
       ticketType: 'snag'
     
    };
    if (this.state.selectedProject && this.state.selectedProject !== '') {
      params.projectId = this.state.selectedProject; // Include projectId only if not "All"
    }
   
    // if ( this.state.status1 === 'me') params.userId = String(UserObj.rec_id)
        if ( this.state.status1 === 'me') params.userId = String(56793)

    this.props.TickList(params);
  };

  componentWillMount() {
    this.fetchServiceAccess();
  }

  fetchServiceAccess = async () => {
    const getCompanyId = UserObj.company_id;

    const response = await getServiceAccess(getCompanyId);
    this.setState({ accessServiceLists: response, loaderServiceAccess: false });
  };

  supportTicketView() {
    mixpanel.track("Reports Support tickets page view", {
      PageName: "Support tickets page",
      UserEmail: UserObj.email,
      UserName: UserObj.fname + " " + UserObj.lname,
      UserId: UserObj.rec_id,
  
      CompanyId: UserObj.company_id,
     
      CompanyName: UserObj.company_name,
      Type: "Support tickets page",
    });
  }

  exportView() {
    mixpanel.track("Reports Support tickets Export", {
      PageName: "Support tickets page",
      UserEmail: UserObj.email,
      UserName: UserObj.fname + " " + UserObj.lname,
      UserId: UserObj.rec_id,
 
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: "Support tickets page",
    });
  }

  async componentDidMount() {
    const userDataLocal = dataUser(); // Fetch user data

    if (userDataLocal) {
      try {
        const UserObj = JSON.parse(userDataLocal);
        this.setState({
          userRole: UserObj.role_data || [], // Ensure it is always an array
        });
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
    await this.locationData1();
  
    if (this.state.locationSpoc && this.state.locationSpoc.length > 0) {
      await this.setuserlist();
    } else {
      console.warn("Skipping setuserlist in componentDidMount: locationSpoc is empty.");
    }
  
    this.supportTicketView();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.state.locationSpoc !== prevState.locationSpoc) {
      if (this.state.locationSpoc && this.state.locationSpoc.length > 0) {
        this.setuserlist();
      } else {
        console.warn("Skipping setuserlist in componentDidUpdate: locationSpoc is empty.");
      }
    }
  }
  
  locationData1 = async () => {
    try {
      let authToken = JSON.parse(localStorage.getItem('headData'));
  
      const axiosConfig = {
        params: {
          spoc: UserObj.rec_id,
          client: this.state.company_id
        },
        headers: {
          Authorization: authToken?.spintlyToken,
        }
      };
  
      const response = await axios.get(`${process.env.REACT_APP_API_URL}basic-data/get-centers-by-spoc`, axiosConfig);
  
      if (response.data.status === "success") {
        this.setState({
          locationSpoc: response.data.data || [] // Ensure an empty array if data is missing
        });
      }
    } catch (error) {
      console.error("Error in locationData1:", error);
    }
  };



  componentWillReceiveProps(props) {
    if (
      props.ticketReducer &&
      this.props.ticketReducer.TicketAllList.status == 200
    ) {
      this.setState({
        TicktingAllListRows:
          props.ticketReducer &&
          this.props.ticketReducer.TicketAllList &&
          this.props.ticketReducer.TicketAllList.data &&
          this.props.ticketReducer.TicketAllList.data.rows,
      });
    }
  }





  refreshPage = (e) => {
    this.setState({
      pgno: 1,
      row: 25,
    });
    let location = (this.state.location1 === 'all')
    ? this.state.locationSpoc?.map((items) => items.centercode) // Send all locations if 'all' is selected
    : this.state.location1 !== null 
      ? this.state.location1 // Send specific location if selected
      : this.state.locationSpoc?.map((items) => items.centercode); 
      let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let param = {
      company_id: newCompanyId?.organizationId,
      row: 25,
      pgno: 1,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      location: location, 
  
      ticketType: 'snag'
    };
    if (this.state.selectedProject && this.state.selectedProject !== '') {
      param.projectId = this.state.selectedProject; // Include projectId only if not "All"
    }
    this.props.TickList(param);
  };
  setParams = () => {
    let raisedByValue1 = this.state.status === 'All' ? '' : this.state.status;
    let params = {
      company_id: this.state.company_id,
      pgno: this.state.pgno,
      row: this.state.row,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      location: this.state.locationSpoc?.map((items) => items.centercode),
      status: raisedByValue1,
    };
   

    return params;
  };



 refreshFilter =()=>{
  
    this.setState({selectedProject:'',location1:'',startDate:'',endDate:'',status:'All'})

  }



  render() {
    const { projects, selectedProject, locationError } = this.state;
    const today = moment().format("YYYY-MM-DD");

    const params = this.setParams();

    var ticketStatus = [

      {
        value: "All",
        label: "All",
      },
      {
        value: "Closed",
        label: "Closed",
      },
    //   {
    //     value: "In Progress",
    //     label: "In Progress",
    //   },
      {
        value: "Open",
        label: "Open",
      },
    
    ];
    var ticketRaisedBy = [
      {
        value: "all",
        label: "All",
      },
      {
        value: "spoc",
        label: "SPOCs",
      },
      {
        value: "me",
        label: "Me",
      },
      {
        value: "nospoc",
        label: "Employees",
      },
    ];




    const { userRole } = this.state;

    // Ensure userRole is available before checking SupportTickets
    const SupportTickets = userRole.find(
      (element) =>
        element.service_id == "17" &&
        (element.role_for_read == "1" || element.role_for_write == "1")
    );



    // Redirect only if userRole has loaded and SupportTickets is missing
    if (userRole.length > 0 && !SupportTickets) {
      return <Navigate to="/Dashboard" />;
    }
    const ticketReducer = this.props.ticketReducer.TicketAllList;
    const Loader = this.props.ticketReducer.loader;

    let serviceAccess = true;
    const serviceAccessId = 17;
    if (this.state.accessServiceLists.length > 0) {
      let serviceAccessobject = {};
      this.state.accessServiceLists.map((e) => {
        if (e.id == serviceAccessId) serviceAccessobject = e;
      });
      serviceAccess = false;
      if (serviceAccessobject)
        serviceAccess = serviceAccessobject.service_access;
    }
    const projectOptions = [
      { value: "", label: "All", ticketType: "" },
      ...this.state.projects.map((item) => ({
        value: item.projectId,
        label: item.projectName,
        ticketType: item.ticketType,
      })),
    ];
    
const locationOptions = [
  { value: "all", label: "All" },
  ...(this.state.locationSpoc || []).map((item) => ({
    value: item.centercode,
    label: item.location_name_zoho,
  })),
];
    const barMenu = {
      items: [
        {
          key: "refresh",
          onClick: this.refreshPage,
          icon: <i className="bi bi-arrow-clockwise" />,
          label: 'Refresh List',
        },
      ],
    };
    
    return (
      <>
      <Layout>
      
      <Sidebar collapsed={this.state.collapsed} />

      <CustomHeader collapsed={this.state.collapsed} toggleCollapsed={this.toggleCollapsed} />
      

      <Layout className={this.state.collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
        <RaiseSnag  
        snagListApi={this.setuserlist}
        show={this.state.showRaiseSnag}
        onClose={() => this.setState({ showRaiseSnag: false })}
        />
        <SnagFilterExport />
        {serviceAccess === true ? (
          <>
             <div className="PageContent">
              <div className="row">
                
                <div className="col-md-6 col-lg-6">
                  <div className='SwHeading'>
                    <h2>Snags</h2>
                  </div>
                </div>
                
                <div className="col-md-12 col-lg-6">
                  <div className="PageHead_Optons_Row">
                    <ul className="PageHead_Optons_RightAligned">
                      
                      <li className="ToHideMobile">
                        <AntDDropdown
                          menu={barMenu}
                          trigger={["click"]}
                          placement="bottomRight"
                        >
                          <SwIconButton size="sm">
                            <i className="bi bi-list" />
                          </SwIconButton>
                        </AntDDropdown>
                      </li>
                      <li>
                        <SwButton
                          size="sm"
                          type="button" 
                          onClick={() => this.setState({ showRaiseSnag: true })}
                        >
                          Raise a snag
                        </SwButton>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-3">
                    <label className="SwFormLabel">Projects Name</label>
                    <SwSelect
                      options={projectOptions}
                      value={projectOptions.find(
                        (opt) => opt.value === this.state.selectedProject
                      )}
                      onChange={(selectedOption) => {
                        if (!selectedOption || selectedOption.value === "") {
                          this.setState({
                            selectedProject: "",
                            ticketType: "",
                          });
                          return;
                        }
                        this.setState({
                          selectedProject: selectedOption.value,
                          ticketType: selectedOption.ticketType,
                        });
                      }}
                      isClearable={false}
                      placeholder="Select Project Name"
                      defaultValue={{ value: "All", label: "All" }}
                    />
                </div>
   
                <div className="col-lg-3">
                  <label className="SwFormLabel">Location</label>
                  <SwSelect
                    options={locationOptions}
                    value={locationOptions.find(
                      (opt) => opt.value === this.state.location1
                    ) || locationOptions[0]}

                    placeholder="Select Location"
                    isClearable={false}

                    onChange={(selectedOption) => {
                      this.setState({
                        location1: selectedOption.value,
                      });
                      this.handelChangeValLang({
                        target: { value: selectedOption.value },
                      });
                    }}
                  />

                </div>

                <div className="col-lg-3">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Start Date</label>
                    <AntDDatePicker
                      format="YYYY-MM-DD"
                      value={
                        this.state.startDate
                          ? dayjs(this.state.startDate,"YYYY-MM-DD")
                          : null
                      }
                      onChange={(date, dateString) =>
                        this.setState({ startDate: dateString })
                      }
                    />
                  </div>
                </div>

                <div className="col-lg-3">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">End Date</label>
                   <AntDDatePicker
                      format="YYYY-MM-DD"
                      value={
                        this.state.endDate
                          ? dayjs(this.state.endDate, "YYYY-MM-DD")
                          : null
                      }
                      disabledDate={(current) =>
                        current && current > dayjs().endOf("day")
                      }
                      onChange={(date, dateString) =>
                        this.setState({ endDate: dateString })
                      }
                    />

                  </div>
                </div>
                  
              </div>
              <div className="row">

                <div className="col-lg-3">
                  <label className="SwFormLabel">Status</label>
                  <SwSelect
                    name="status"
                    onChange={this.StatusMethod}
                    options={ticketStatus}
                    value={ticketStatus.find(option => option.value === this.state.status)}
                    defaultValue={{ value: "All", label: "All" }}
                    isClearable={false}
                  />
                </div>
                  <div className="col-lg-3">
                  
                    <label className="SwFormLabel invisible">No Label</label>
                    <SwButton
                      size="sm"
                      variant = "dark"
                      type="submit"
                      onClick={this.submitFilter}
                      className="me-2"
                    >
                      Apply Filter
                    </SwButton>
                    <SwButton
                      size="sm"
                      variant = "dark-outline"
                      type="submit"
                      onClick={this.refreshFilter}
                    >
                     Clear Filter
                    </SwButton>
                  
                </div>

              </div>

              <div className="row">
                <div className="col-12">
                  <div className="position-relative">
                    <div
                      className={Loader == true ? "loader disable" : "loader mt-3 rounded border"}
                    >
                      <img
                        style={{top:'100px'}}
                        src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                        alt="Loder"
                      />
                    </div>
                    <SnagTable
                      params={params}
                      pageSize={this.state.row}
                      currentPage={this.state.pgno}
                      totalRecords={this.state.TicktingAllListRows}
                      onPageChange={(page, pageSize) => {
                        this.setState({ pgno: page, row: pageSize }, () => {
                          this.setuserlist();
                        });
                      }}
                    />

                  </div>
                </div>
              </div>
            </div>
          </>
        ) : this.state.loaderServiceAccess == true ? (
          <>
            <SwLoader />
          </>
        ) : (
          <MarketingPanel />
        )}
           </Layout>

</Layout>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  ticketReducer: state.ticketReducer,
});

const mapActionsToProps = {
  TickList,
  CheckLoader,
};

export default connect(mapStateToProps, mapActionsToProps)(SnagManagement);
